import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Center, Loader } from '@mantine/core';
import { APP_ROUTES } from '../../navigation/appRoutes';
import {
  usePermissionContext,
  useResourcePermissionsReady,
} from '../../permissions/scheduler';
import { useResourcePermissionsStore } from '../../stores/zustand/resourcePermissionsStore';
import { SchedulerAccessDenied } from '../../components/auth/SchedulerPermissionGate';

/**
 * Root redirect — first allowed scheduler path (permissions-aware).
 * Preserves legacy `?view=reports` when the user can view reports.
 */
export function RootRedirect() {
  const [searchParams] = useSearchParams();
  const view = searchParams.get('view');
  const permissionContext = usePermissionContext();
  const { status, isLoading } = useResourcePermissionsReady();
  const getDefaultLandingPath = useResourcePermissionsStore((s) => s.getDefaultLandingPath);
  const canAccessPath = useResourcePermissionsStore((s) => s.canAccessPath);

  if (isLoading || status === 'idle' || status === 'loading') {
    return (
      <Center style={{ flex: 1, minHeight: 280, height: '100%' }}>
        <Loader size="md" />
      </Center>
    );
  }

  if (status === 'error') {
    return <SchedulerAccessDenied />;
  }

  if (view === 'reports' && canAccessPath(APP_ROUTES.reports.locationHealth, permissionContext)) {
    return <Navigate to={APP_ROUTES.reports.locationHealth} replace />;
  }

  const landing = getDefaultLandingPath(permissionContext);
  if (landing) {
    return <Navigate to={landing} replace />;
  }

  return <SchedulerAccessDenied />;
}
